import React from "react"
import { Image } from "react-bootstrap"

const image_url =
  "https://avatars1.githubusercontent.com/u/11337871?s=460&u=03b7fe077560155668c7f169ae0f9e784fde5efb&v=4"

// "https://avatars1.githubusercontent.com/u/11337871?s=460&u=03b7fe077560155668c7f169ae0f9e784fde5efb&v=4"

// TODO: Async Pending
// async function showAvatar() {
//   let img = fetch(
//     "https://avatars1.githubusercontent.com/u/11337871?s=460&u=03b7fe077560155668c7f169ae0f9e784fde5efb&v=4"
//   )

//   return img
//     .then(res => res.url)
//     .catch(err => {
//       throw new Error("Something went wrong")
//     })
// }

export default function () {
  return (
    <div>
      <Image
        src={image_url}
        height="256"
        width="256"
        alt="Debajit Deb"
        rounded
        style={{
          margin: 30,
          filter: "grayscale(100%)",
        }}
      />
    </div>
  )
}
